export function debounce<T extends (...args: any[]) => any>(
  fn: T,
  delay: number
): T & { cancel: () => void } {
  let timeoutId: NodeJS.Timeout | undefined

  const debouncedFn = (...args: Parameters<T>): ReturnType<T> => {
    if (timeoutId) {
      clearTimeout(timeoutId)
    }

    return new Promise((resolve) => {
      timeoutId = setTimeout(() => {
        resolve(fn(...args))
      }, delay)
    }) as ReturnType<T>
  }

  debouncedFn.cancel = () => {
    if (timeoutId) {
      clearTimeout(timeoutId)
    }
  }

  return debouncedFn as T & { cancel: () => void }
}

export type DebouncedFunction<T extends (...args: any[]) => any> = T & {
  cancel: () => void
}